import type { Item } from '@/schemas/equipment';

/**
 * **FI-49 (2026-05-22)** — helper promosso da `SectionEquipment` per essere
 * riusato in `FullSheet` (Hub) e ovunque serva il display tagliato di un
 * oggetto.
 *
 * Aggrega i campi meccanici di un Item in una lista piatta di etichette
 * visualizzate come tag pill. Match al manuale + mockup: ogni proprietà
 * numerica ha la sua label dedicata (es. "5 utilizzi", "peso 1", "+1 danni",
 * "1 Armatura", "+2 perforante"). Tags raw vengono prima, seguiti dalle
 * proprietà strutturate nell'ordine convenzionale del manuale:
 * `tags → utilizzi → danni → armatura → perforante → peso`.
 *
 * Il `peso` è ultimo per coerenza con il pattern manuale (le proprietà di
 * gioco precedono il dato logistico). Anche `weight = 0` viene incluso
 * esplicitamente come `peso 0` — la mancanza del campo darebbe l'illusione
 * di un peso indeterminato.
 */
export function displayTagsForItem(item: Item): string[] {
  const tags: string[] = [];
  for (const t of item.tags) tags.push(t);
  if (item.uses !== undefined) tags.push(`${item.uses} utilizzi`);
  if (item.damage) tags.push(item.damage);
  if (item.armor !== undefined) tags.push(`${item.armor} Armatura`);
  if (item.armorPiercing !== undefined) {
    tags.push(item.armorPiercing > 0 ? `+${item.armorPiercing} perforante` : 'perforante');
  }
  tags.push(`peso ${item.weight}`);
  return tags;
}
